import styled from "styled-components";

const Container = styled.div.attrs(props => ({ className: "container" }))``;

export default Container;
